<template>
  <component :is="businessComponentName"></component>
</template>

<script>
import { GetTaskDetailComponentName } from "./basicTaskHandler.js";

export default {
  data() {
    return {
      businessComponentName: "div"
    };
  },

  watch: {
    task: function(newvalue) {
      if (!newvalue) return;
      console.log(newvalue.TASKTYPENAME);
      let taskType = newvalue.TASKTYPE;
      let taskClass = newvalue.TASKCLASS;
      if(taskClass)
      GetTaskDetailComponentName(taskType, taskClass).then(componentName => {
        console.log(componentName);
        this.businessComponentName = componentName;
      });
    }
  },
  mounted() {
    if (!this.task) return;
    let taskType = this.task.TASKTYPE;
    let taskClass = this.task.TASKCLASS;
    if(taskClass)
    GetTaskDetailComponentName(taskType, taskClass).then(componentName => {
      console.log(componentName);
      this.businessComponentName = componentName;
    });
  },
  computed: {
    task() {
      return this.$store.state.task.curTask;
    }
  }
};
</script>

<style scoped>
</style>